module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-28-af8e50b17d342704e4f6f7e202a23758.png";